import React from "react";

const colors = [
  [226, 95, 81], // A
  [242, 96, 145], // B
  [187, 101, 202], // C
  [149, 114, 207], // D
  [120, 132, 205], // E
  [91, 149, 249], // F
  [72, 194, 249], // G
  [69, 208, 226], // H
  [72, 182, 172], // I
  [82, 188, 137], // J
  [155, 206, 95], // K
  [212, 227, 74], // L
  [254, 218, 16], // M
  [247, 192, 0], // N
  [255, 168, 0], // O
  [255, 138, 96], // P
  [44, 62, 80], // Q
  [143, 164, 175], // R
  [162, 136, 126], // S
  [163, 163, 163], // T
  [175, 181, 226], // U
  [179, 155, 221], // V
  [194, 194, 194], // W
  [124, 222, 235], // X
  [188, 170, 164], // Y
  [173, 214, 125], // Z
];

const mixColors = (colA, colB, blendRatio) => {
  var col = [0, 0, 0];
  for (var i = 0; i < 2; i++) {
    col[i] = Math.round((colB[i] - colA[i]) * blendRatio + colA[i]);
  }
  return col;
};

class LetterAvatar extends React.Component {
  render() {
    const { name, profile_picture, size, radius, inline, customColor } =
      this.props;
    var initials = "A";

    if (name) {
      const letters = name.trim().toUpperCase().split(" ");
      initials = letters[0][0];
    }

    var rgb = [0, 0, 0];
    if (customColor) {
      rgb = customColor;
    } else {
      if (/[A-Z]+/.test(initials)) {
        if (initials.length > 1) {
          let indexA = initials.charCodeAt(0) - 65;
          let indexB = initials.charCodeAt(1) - 65;
          rgb = mixColors(colors[indexA], colors[indexB], 0.8);
        } else {
          let index = initials.charCodeAt(0) - 65;
          rgb = colors[index];
        }
      }
    }

    let style = {
      display: "block",
      backgroundColor: `rgb(${rgb})`,
      width: size,
      height: size,
      fontSize: Math.floor(size / 2.5) + "px",
      lineHeight: size + Math.floor(size / 10) + "px",
      color: "rgb(255,255,255)",
      textAlign: "center",
      borderRadius: radius,
    };

    if (inline) style = { ...style, display: "inline-block" };

    return <div style={style}>{initials}</div>;
  }
}

export default LetterAvatar;
